module.exports = __webpack_public_path__ + "images/ea3eab25c9d8c9672fbd56b8b9a18ca4-saveR.svg";